export default "__VITE_ASSET__8a954521__"